import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const Fideicomisos = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Fideicomisos</h1>

                <p className='text-xl font-sans text-center'>
                    Un fideicomiso o fidecomiso es un contrato en virtud del cual una o más personas (fideicomitente/s o fiduciante/s) transmiten bienes, cantidades de dinero o derechos, presentes o futuros, de su propiedad a otra persona (fiduciaria, que puede ser una persona física o jurídica) para que ésta administre o invierta los bienes en beneficio propio o en beneficio de un tercero, llamado beneficiario, y se transmita su propiedad, al cumplimiento de un plazo o condición, al fideicomisario, que puede ser el fiduciante, el beneficiario u otra persona.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Fideicomisos.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>

            </div>
        </div>
    );
}

export default Fideicomisos;